<script setup>
import { Motion, AnimatePresence } from 'motion-v'

const { hasNotifications, delay } = defineProps({
    hasNotifications: { type: Boolean, default: false },
    // ms to wait after mount before the dot pops in, so the intro lands after the app has rendered
    delay: { type: Number, default: 600 },
})

const isReady = ref(false)
const isIntroComplete = ref(false)

const showDot = computed(() => hasNotifications && isReady.value)
const showPulse = computed(() => showDot.value && isIntroComplete.value)

onMounted(() => {
    useTimeoutFn(() => (isReady.value = true), delay)
})

watch(showDot, (visible) => {
    if (!visible) isIntroComplete.value = false
})
</script>

<template>
    <span data-testid="notifications-indicator" class="relative inline-flex size-2 items-center justify-center">
        <AnimatePresence>
            <Motion
                v-if="showDot"
                key="dot"
                data-testid="notifications-indicator-dot"
                :initial="{ scale: 0, opacity: 0 }"
                :animate="{ scale: 1, opacity: 1, transition: { type: 'spring', stiffness: 600, damping: 16 } }"
                :exit="{ scale: 0, opacity: 0, transition: { duration: 0.15 } }"
                class="relative size-1.5 rounded-full bg-pink-400 ring-2 ring-white"
                @animation-complete="isIntroComplete = true"
            >
                <Motion
                    v-if="showPulse"
                    data-testid="notifications-indicator-pulse"
                    :initial="{ scale: 1, opacity: 0.8 }"
                    :animate="{
                        scale: 3.3,
                        opacity: 0,
                        transition: { duration: 7, ease: 'easeOut', repeat: Infinity, repeatDelay: 0.8 },
                    }"
                    class="pointer-events-none absolute inset-0 rounded-full border border-pink-500"
                />
            </Motion>
        </AnimatePresence>
    </span>
</template>
